import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _addressWithContact = { address: '_apiAddress' };
var _addToCheckoutRequest = {
    lineItems: '_lineItem',
    customLineItems: '_customLineItem',
};
var _addToCheckoutResponse = { checkout: '_checkout' };
var _apiAddress = { geocode: '_addressLocation' };
var _appliedDiscount = { merchantDiscount: '_merchantDiscount' };
var _carrierServiceOption = { shippingOptions: '_shippingOption' };
var _catalogOverrideFields = { physicalProperties: '_physicalProperties' };
var _charge = { cycleBillingDate: 'google.protobuf.Timestamp' };
var _checkout = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    lineItems: '_lineItem',
    billingInfo: '_addressWithContact',
    shippingInfo: '_shippingInfo',
    appliedDiscounts: '_appliedDiscount',
    membershipOptions: '_membershipOptions',
    subscriptionCharges: '_subscriptionCharges',
};
var _createCheckoutRequest = {
    checkoutInfo: '_checkout',
    lineItems: '_lineItem',
    customLineItems: '_customLineItem',
};
var _createCheckoutResponse = { checkout: '_checkout' };
var _createOrderAndChargeRequest = {};
var _createOrderAndChargeResponse = {};
var _createOrderRequest = {};
var _createOrderResponse = {};
var _customLineItem = {
    physicalProperties: '_physicalProperties',
    subscriptionOptionInfo: '_subscriptionOptionInfo',
    serviceProperties: '_serviceProperties',
};
var _deliveryLogistics = {
    pickupDetails: '_pickupDetails',
    deliveryTimeSlot: '_deliveryTimeSlot',
};
var _deliveryTimeSlot = {
    from: 'google.protobuf.Timestamp',
    to: 'google.protobuf.Timestamp',
};
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getCheckoutByCartIdRequest = {};
var _getCheckoutByCartIdResponse = { checkout: '_checkout' };
var _getCheckoutPaymentSettingsRequest = {};
var _getCheckoutPaymentSettingsResponse = {};
var _getCheckoutRequest = {};
var _getCheckoutResponse = { checkout: '_checkout' };
var _getCheckoutURLRequest = {};
var _getCheckoutURLResponse = {};
var _getWixCheckoutURLRequest = {};
var _getWixCheckoutURLResponse = {};
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _invalidMembership = { membership: '_membership' };
var _lineItem = {
    media: '_image',
    physicalProperties: '_physicalProperties',
    subscriptionOptionInfo: '_subscriptionOptionInfo',
    serviceProperties: '_serviceProperties',
    catalogOverrideFields: '_catalogOverrideFields',
};
var _markCheckoutAsCompletedAndRedirectToUrlRequest = {};
var _markCheckoutAsCompletedRequest = {};
var _markCheckoutAsCompletedResponse = {};
var _membership = { expirationDate: 'google.protobuf.Timestamp' };
var _membershipOptions = {
    eligibleMemberships: '_membership',
    invalidMemberships: '_invalidMembership',
};
var _merchantDiscount = { percentage: 'google.protobuf.DoubleValue' };
var _physicalProperties = { weight: 'google.protobuf.DoubleValue' };
var _pickupDetails = { address: '_apiAddress' };
var _rawHttpResponse = { body: 'BYTES' };
var _removeCouponRequest = {};
var _removeCouponResponse = { checkout: '_checkout' };
var _removeGiftCardRequest = {};
var _removeGiftCardResponse = { checkout: '_checkout' };
var _removeLineItemsRequest = {};
var _removeLineItemsResponse = { checkout: '_checkout' };
var _removeOverrideCheckoutUrlRequest = {};
var _removeOverrideCheckoutUrlResponse = { checkout: '_checkout' };
var _selectedCarrierServiceOption = { logistics: '_deliveryLogistics' };
var _serviceProperties = { scheduledDate: 'google.protobuf.Timestamp' };
var _shippingInfo = {
    shippingDestination: '_addressWithContact',
    selectedCarrierServiceOption: '_selectedCarrierServiceOption',
    carrierServiceOptions: '_carrierServiceOption',
};
var _shippingOption = { logistics: '_deliveryLogistics' };
var _subscriptionCharges = { charges: '_charge' };
var _subscriptionOptionInfo = {
    subscriptionSettings: '_subscriptionSettings',
};
var _subscriptionSettings = { startDate: 'google.protobuf.Timestamp' };
var _updateCheckoutRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    checkout: '_checkout',
    lineItems: '_lineItem',
    customLineItems: '_customLineItem',
};
var _updateCheckoutResponse = { checkout: '_checkout' };
var _updateLineItemsQuantityRequest = {};
var _updateLineItemsQuantityResponse = { checkout: '_checkout' };
function resolveComWixEcomCheckoutApiV1CheckoutServiceUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/ecom/v1/checkouts',
                destPath: '/v1/checkouts',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/checkout',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/ecom/v1/checkouts',
                destPath: '/v1/checkouts',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/ecom/v1/checkouts',
                destPath: '/v1/checkouts',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/ecom/v1/checkouts',
                destPath: '/v1/checkouts',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/ecom/v1/checkouts',
                destPath: '/v1/checkouts',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/ecom/v1/checkouts',
                destPath: '/v1/checkouts',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/ecom/v1/checkouts',
                destPath: '/v1/checkouts',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a checkout.
 *
 * A checkout must include at least 1 item in `lineItems` or `customLineItems`.
 *
 * If passing `checkoutInfo.customFields`, then `checkoutInfo.customFields.value` is a required field.
 */
export function createCheckout(payload) {
    var _a = serializer(_createCheckoutRequest, {
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _apiAddress: _apiAddress,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _catalogOverrideFields: _catalogOverrideFields,
        _charge: _charge,
        _checkout: _checkout,
        _customLineItem: _customLineItem,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInfo: _shippingInfo,
        _shippingOption: _shippingOption,
        _subscriptionCharges: _subscriptionCharges,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCheckoutResponse, {
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _apiAddress: _apiAddress,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _catalogOverrideFields: _catalogOverrideFields,
        _charge: _charge,
        _checkout: _checkout,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInfo: _shippingInfo,
        _shippingOption: _shippingOption,
        _subscriptionCharges: _subscriptionCharges,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __createCheckout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'POST',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.CreateCheckout',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCheckout.fromReq = fromReq;
    __createCheckout.__isAmbassador = true;
    return __createCheckout;
}
/** Retrieves a checkout. */
export function getCheckout(payload) {
    var _a = serializer(_getCheckoutRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCheckoutResponse, {
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _apiAddress: _apiAddress,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _catalogOverrideFields: _catalogOverrideFields,
        _charge: _charge,
        _checkout: _checkout,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInfo: _shippingInfo,
        _shippingOption: _shippingOption,
        _subscriptionCharges: _subscriptionCharges,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __getCheckout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'GET',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.GetCheckout',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCheckout.fromReq = fromReq;
    __getCheckout.__isAmbassador = true;
    return __getCheckout;
}
/** Retrieves the checkout associated with a specified cart. */
export function getCheckoutByCartId(payload) {
    var _a = serializer(_getCheckoutByCartIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCheckoutByCartIdResponse, {
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _apiAddress: _apiAddress,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _catalogOverrideFields: _catalogOverrideFields,
        _charge: _charge,
        _checkout: _checkout,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInfo: _shippingInfo,
        _shippingOption: _shippingOption,
        _subscriptionCharges: _subscriptionCharges,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __getCheckoutByCartId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'GET',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.GetCheckoutByCartId',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/by-cart-id/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCheckoutByCartId.fromReq = fromReq;
    __getCheckoutByCartId.__isAmbassador = true;
    return __getCheckoutByCartId;
}
/** Deprecated and will be removed soon, use GetCheckoutURL */
export function getWixCheckoutUrl(payload) {
    var _a = serializer(_getWixCheckoutURLRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWixCheckoutURLResponse, {}).fromJSON;
    function __getWixCheckoutUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'GET',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.GetWixCheckoutURL',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{id}/wix-checkout-url',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWixCheckoutUrl.fromReq = fromReq;
    __getWixCheckoutUrl.__isAmbassador = true;
    return __getWixCheckoutUrl;
}
/**
 * Retrieves the checkout page URL of a specified checkout.
 *
 * By default, a `checkoutUrl` generates for a checkout and directs to a standard Wix checkout page.
 * However, if `overrideCheckoutUrl` has a value, it will replace and set the value of `checkoutUrl`.
 */
export function getCheckoutUrl(payload) {
    var _a = serializer(_getCheckoutURLRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCheckoutURLResponse, {}).fromJSON;
    function __getCheckoutUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'GET',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.GetCheckoutURL',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{id}/checkout-url',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCheckoutUrl.fromReq = fromReq;
    __getCheckoutUrl.__isAmbassador = true;
    return __getCheckoutUrl;
}
/**
 * Updates a checkout.
 *
 * Use this method to update checkout fields such as billing and shipping info, or to add a coupon code or gift card.
 *
 * To update a checkout's `lineItems`, `completed` status, or to remove coupons and gift cards, see these methods:
 * + Add to Checkout: Add line items to the checkout.
 * + Update Line Items Quantity: Update the quantity of 1 or more line items in the checkout.
 * + Remove Line Items: Remove a line item from the checkout.
 * + Mark Checkout As Completed: To update `completed` to `true` if the checkout was completed through a non-Wix orders or payments system.
 * + Remove Coupon: To remove an applied coupon from the checkout.
 * + Remove Gift Card: To remove an applied gift card from the checkout.
 *
 * >**Notes:**
 * > + If nothing is passed in the request, the call will fail.
 * > + The `checkout.buyerInfo.email` may not be removed once it is set.
 */
export function updateCheckout(payload) {
    var _a = serializer(_updateCheckoutRequest, {
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _apiAddress: _apiAddress,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _catalogOverrideFields: _catalogOverrideFields,
        _charge: _charge,
        _checkout: _checkout,
        _customLineItem: _customLineItem,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInfo: _shippingInfo,
        _shippingOption: _shippingOption,
        _subscriptionCharges: _subscriptionCharges,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCheckoutResponse, {
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _apiAddress: _apiAddress,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _catalogOverrideFields: _catalogOverrideFields,
        _charge: _charge,
        _checkout: _checkout,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInfo: _shippingInfo,
        _shippingOption: _shippingOption,
        _subscriptionCharges: _subscriptionCharges,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateCheckout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'PATCH',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.UpdateCheckout',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{checkout.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCheckout.fromReq = fromReq;
    __updateCheckout.__isAmbassador = true;
    return __updateCheckout;
}
/** Removes the coupon from a specified checkout. */
export function removeCoupon(payload) {
    var _a = serializer(_removeCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeCouponResponse, {
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _apiAddress: _apiAddress,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _catalogOverrideFields: _catalogOverrideFields,
        _charge: _charge,
        _checkout: _checkout,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInfo: _shippingInfo,
        _shippingOption: _shippingOption,
        _subscriptionCharges: _subscriptionCharges,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __removeCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'POST',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.RemoveCoupon',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{id}/remove-coupon',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeCoupon.fromReq = fromReq;
    __removeCoupon.__isAmbassador = true;
    return __removeCoupon;
}
/**
 * Removes the gift card from a specified checkout.
 *
 * A checkout can only hold 1 gift card.
 */
export function removeGiftCard(payload) {
    var _a = serializer(_removeGiftCardRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeGiftCardResponse, {
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _apiAddress: _apiAddress,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _catalogOverrideFields: _catalogOverrideFields,
        _charge: _charge,
        _checkout: _checkout,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInfo: _shippingInfo,
        _shippingOption: _shippingOption,
        _subscriptionCharges: _subscriptionCharges,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __removeGiftCard(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'POST',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.RemoveGiftCard',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{id}/remove-gift-card',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeGiftCard.fromReq = fromReq;
    __removeGiftCard.__isAmbassador = true;
    return __removeGiftCard;
}
/**
 * Removes the `overrideCheckoutUrl` from a specified checkout.
 *
 * When `overrideCheckoutUrl` is removed, the `checkoutUrl` will be set to the default, standard
 * Wix checkout page URL.
 */
export function removeOverrideCheckoutUrl(payload) {
    var _a = serializer(_removeOverrideCheckoutUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeOverrideCheckoutUrlResponse, {
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _apiAddress: _apiAddress,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _catalogOverrideFields: _catalogOverrideFields,
        _charge: _charge,
        _checkout: _checkout,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInfo: _shippingInfo,
        _shippingOption: _shippingOption,
        _subscriptionCharges: _subscriptionCharges,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __removeOverrideCheckoutUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'POST',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.RemoveOverrideCheckoutUrl',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{id}/remove-override-checkout-url',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeOverrideCheckoutUrl.fromReq = fromReq;
    __removeOverrideCheckoutUrl.__isAmbassador = true;
    return __removeOverrideCheckoutUrl;
}
/**
 * Adds catalog line items and/or custom line items to a checkout.
 *
 * When adding catalog ([SDK](https://dev.wix.com/docs/sdk/backend-modules/stores/catalog-v3/e-commerce-integration) | [REST](https://dev.wix.com/docs/rest/business-solutions/stores/catalog/e-commerce-integration)) items
 * to a checkout, the `lineItems.catalogReference.appId` and `lineItems.catalogReference.catalogItemId` fields are required.
 */
export function addToCheckout(payload) {
    var _a = serializer(_addToCheckoutRequest, {
        _catalogOverrideFields: _catalogOverrideFields,
        _customLineItem: _customLineItem,
        _focalPoint: _focalPoint,
        _image: _image,
        _lineItem: _lineItem,
        _physicalProperties: _physicalProperties,
        _serviceProperties: _serviceProperties,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addToCheckoutResponse, {
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _apiAddress: _apiAddress,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _catalogOverrideFields: _catalogOverrideFields,
        _charge: _charge,
        _checkout: _checkout,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInfo: _shippingInfo,
        _shippingOption: _shippingOption,
        _subscriptionCharges: _subscriptionCharges,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __addToCheckout(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'POST',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.AddToCheckout',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{id}/add-to-checkout',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addToCheckout.fromReq = fromReq;
    __addToCheckout.__isAmbassador = true;
    return __addToCheckout;
}
/** Removes line items from the specified checkout. */
export function removeLineItems(payload) {
    var _a = serializer(_removeLineItemsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeLineItemsResponse, {
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _apiAddress: _apiAddress,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _catalogOverrideFields: _catalogOverrideFields,
        _charge: _charge,
        _checkout: _checkout,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInfo: _shippingInfo,
        _shippingOption: _shippingOption,
        _subscriptionCharges: _subscriptionCharges,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __removeLineItems(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'POST',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.RemoveLineItems',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{id}/remove-line-items',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeLineItems.fromReq = fromReq;
    __removeLineItems.__isAmbassador = true;
    return __removeLineItems;
}
/**
 * Creates an order from a specified checkout.
 *
 * For an order to be created from a checkout, the following requirements must be met:
 * + A checkout cannot have calculation errors. Pass the checkout ID to Get Checkout and review the `calculationErrors` field.
 * + A checkout must have at least 1 line item or custom line item.
 * + All of the line Items have an `availability.status` of `"AVAILABLE"` or `"PARTIALLY_AVAILABLE"`.
 * + If there is a payment to be made, meaning that `priceSummary.total` is greater than `0`, the `billingInfo.address` field are required.
 * + When a checkout has line items to be shipped, the `shippingInfo.shippingDestination.address` and `shippingInfo.selectedCarrierServiceOption` fields are required.
 * + When a checkout has line items for pickup, the `shippingInfo.selectedCarrierServiceOption.logistics.pickupDetails` field are required.
 */
export function createOrder(payload) {
    var _a = serializer(_createOrderRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOrderResponse, {}).fromJSON;
    function __createOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'POST',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.CreateOrder',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{id}/create-order',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOrder.fromReq = fromReq;
    __createOrder.__isAmbassador = true;
    return __createOrder;
}
/** Deprecated (use createOrder instead) */
export function createOrderAndCharge(payload) {
    var _a = serializer(_createOrderAndChargeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOrderAndChargeResponse, {}).fromJSON;
    function __createOrderAndCharge(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'POST',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.CreateOrderAndCharge',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{id}/create-order-and-charge',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOrderAndCharge.fromReq = fromReq;
    __createOrderAndCharge.__isAmbassador = true;
    return __createOrderAndCharge;
}
/** Marks a checkout as completed and redirects to a specified URL. */
export function markCheckoutAsCompletedAndRedirectToUrl(payload) {
    var _a = serializer(_markCheckoutAsCompletedAndRedirectToUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __markCheckoutAsCompletedAndRedirectToUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'GET',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.MarkCheckoutAsCompletedAndRedirectToUrl',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/mark-checkout-as-completed-and-redirect-to-url',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markCheckoutAsCompletedAndRedirectToUrl.fromReq = fromReq;
    __markCheckoutAsCompletedAndRedirectToUrl.__isAmbassador = true;
    return __markCheckoutAsCompletedAndRedirectToUrl;
}
/**
 * Sets `completed` to `true` to mark a checkout as completed.
 *
 * When an order is completed through Wix, the `completed` field in the associated checkout object
 * will automatically be updated to `true`. If an order is completed through a separate system,
 * use this method to manually mark the checkout as completed.
 */
export function markCheckoutAsCompleted(payload) {
    var _a = serializer(_markCheckoutAsCompletedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markCheckoutAsCompletedResponse, {}).fromJSON;
    function __markCheckoutAsCompleted(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'POST',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.MarkCheckoutAsCompleted',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{id}/mark-as-completed',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markCheckoutAsCompleted.fromReq = fromReq;
    __markCheckoutAsCompleted.__isAmbassador = true;
    return __markCheckoutAsCompleted;
}
/**
 * Updates the quantity of one or more line items in a checkout.
 *
 * This method is only for updating the quantity of line items. To entirely remove a line item from
 * the checkout, use the Remove Line Items method.
 * To add a new line item to the checkout, use the Add to Checkout method.
 *
 * This method checks the amount of stock remaining for this line item. If the specified `quantity`
 * is greater than the remaining stock, then the `quantity` returned in the response is the total amount
 * of remaining stock.
 */
export function updateLineItemsQuantity(payload) {
    var _a = serializer(_updateLineItemsQuantityRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateLineItemsQuantityResponse, {
        _addressLocation: _addressLocation,
        _addressWithContact: _addressWithContact,
        _apiAddress: _apiAddress,
        _appliedDiscount: _appliedDiscount,
        _carrierServiceOption: _carrierServiceOption,
        _catalogOverrideFields: _catalogOverrideFields,
        _charge: _charge,
        _checkout: _checkout,
        _deliveryLogistics: _deliveryLogistics,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _focalPoint: _focalPoint,
        _image: _image,
        _invalidMembership: _invalidMembership,
        _lineItem: _lineItem,
        _membership: _membership,
        _membershipOptions: _membershipOptions,
        _merchantDiscount: _merchantDiscount,
        _physicalProperties: _physicalProperties,
        _pickupDetails: _pickupDetails,
        _selectedCarrierServiceOption: _selectedCarrierServiceOption,
        _serviceProperties: _serviceProperties,
        _shippingInfo: _shippingInfo,
        _shippingOption: _shippingOption,
        _subscriptionCharges: _subscriptionCharges,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _subscriptionSettings: _subscriptionSettings,
    }).fromJSON;
    function __updateLineItemsQuantity(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'POST',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.UpdateLineItemsQuantity',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{id}/update-line-items-quantity',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateLineItemsQuantity.fromReq = fromReq;
    __updateLineItemsQuantity.__isAmbassador = true;
    return __updateLineItemsQuantity;
}
export function getCheckoutPaymentSettings(payload) {
    var _a = serializer(_getCheckoutPaymentSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCheckoutPaymentSettingsResponse, {}).fromJSON;
    function __getCheckoutPaymentSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.checkout',
            method: 'GET',
            methodFqn: 'com.wix.ecom.checkout.api.v1.CheckoutService.GetCheckoutPaymentSettings',
            url: resolveComWixEcomCheckoutApiV1CheckoutServiceUrl({
                protoPath: '/v1/checkouts/{id}/payment-settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCheckoutPaymentSettings.fromReq = fromReq;
    __getCheckoutPaymentSettings.__isAmbassador = true;
    return __getCheckoutPaymentSettings;
}
//# sourceMappingURL=http.impl.js.map